import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UpdateAttendanceComponent } from './update-attendance/update-attendance.component';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-attendances-table',
  templateUrl: './attendances-table.component.html',
  styles: ``
})
export class AttendancesTableComponent {

  @Input() data!: any;
  @Input() isWeekend: boolean | undefined;
  @Output() refreshDetails = new EventEmitter(false);

  showEditAtrendace: boolean = false;
  reason_leave!: string
  reason_attend!: string
  savedScrollY = 0;

  constructor(private dialog: MatDialog,
    private authService: AuthenticationService
  ) { }
  ngOnInit(): void {
    // // debugger
    this.showEditAtrendace = this.authService.currentUserValue?.is_hr_manager || this.authService.currentUserValue?.type == "company" || false;
  }

  ngOnChanges(changes: any): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (changes.data) {
      this.data?.map((attendance: any) => {
        if (attendance?.attendance?.attendances) {
          attendance.attendance.attendances.over_time_hours = Math.floor(attendance?.attendance?.attendances?.over_time_seconds / 3600) || 0;
          attendance.attendance.attendances.over_time_minutes = Math.floor((attendance?.attendance?.attendances?.over_time_seconds % 3600) / 60) || 0;
        }
        if (attendance?.attendance?.attendances) {
          attendance.attendance.attendances.minus_time_hours = Math.floor(attendance?.attendance?.attendances?.minus_time_seconds / 3600) || 0;
          attendance.attendance.attendances.minus_time_minutes = Math.floor((attendance?.attendance?.attendances?.minus_time_seconds % 3600) / 60) || 0;
        }
      });
      if (this.savedScrollY) {
        window.scrollTo(0, this.savedScrollY);
      }
    }
  }

  UpdateAttendance(attendance: any, type: string, index?: number) {
    let DialogData = {
      type,
      index: (index != undefined) ? index + 1 : 0,
      history: [{ id: attendance?.attendances?.id, time_in: attendance?.attendances?.time_in, time_out: attendance?.attendances?.time_out }, ...attendance.attendances.history]
    }
    // // debugger
    const dialogRef = this.dialog.open(UpdateAttendanceComponent, {
      width: '540px',
      data: DialogData
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.savedScrollY = window.scrollY;
        this.refreshDetails.emit(Date.now());
        // if (index == undefined) {
        //   // debugger
        //   if (type == 'check-in') {
        //     attendance.attendances.time_in = new Date().setHours(res.time.split(":")[0], res.time.split(":")[1], 0, 0);
        //     attendance.attendances.reason_correct_sign_in = res.reason;
        //   } else {
        //     attendance.attendances.time_out = new Date().setHours(res.time.split(":")[0], res.time.split(":")[1], 0, 0);
        //     attendance.attendances.reason_correct_sign_out = res.reason;
        //   }

        //   if (type == 'check-in' && (!attendance.has_correct_sign_in_or_sign_out || attendance.has_correct_sign_in_or_sign_out == 'correct_sign_in')) {
        //     attendance.has_correct_sign_in_or_sign_out = 'correct_sign_in'
        //   } else if (type == 'check-out' && (!attendance.has_correct_sign_in_or_sign_out || attendance.has_correct_sign_in_or_sign_out == 'correct_sign_out')) {
        //     attendance.has_correct_sign_in_or_sign_out = 'correct_sign_out'
        //   } else {
        //     attendance.has_correct_sign_in_or_sign_out = 'correct_sign_in_and_sign_out';
        //   }
        // } else if (index >= 0) {
        //   // debugger
        //   if (type == 'check-in') {
        //     attendance.attendances.history[index].time_in = new Date().setHours(res.time.split(":")[0], res.time.split(":")[1], 0, 0);
        //     attendance.attendances.history[index].reason_correct_sign_in = res.reason;
        //   } else {
        //     attendance.attendances.history[index].time_out = new Date().setHours(res.time.split(":")[0], res.time.split(":")[1], 0, 0);
        //     attendance.attendances.history[index].reason_correct_sign_out = res.reason;
        //   }

        //   if (type == 'check-in' && (!attendance?.attendances.history[index].has_correct_sign_in_or_sign_out || attendance?.attendances.history[index].has_correct_sign_in_or_sign_out == 'correct_sign_in')) {
        //     attendance.attendances.history[index].has_correct_sign_in_or_sign_out = 'correct_sign_in'
        //   } else if (type == 'check-out' && (!attendance.attendances.history[index].has_correct_sign_in_or_sign_out || attendance.attendances.history[index].has_correct_sign_in_or_sign_out == 'correct_sign_out')) {
        //     attendance.attendances.history[index].has_correct_sign_in_or_sign_out = 'correct_sign_out'
        //   } else {
        //     attendance.attendances.history[index].has_correct_sign_in_or_sign_out = 'correct_sign_in_and_sign_out';
        //   }
        // }
      }
    })
  }


  isToday(dateString: string): boolean {
    const inputDate = new Date(dateString);
    const today = new Date();

    return inputDate.getUTCDate() === today.getUTCDate() &&
      inputDate.getUTCMonth() === today.getUTCMonth() &&
      inputDate.getUTCFullYear() === today.getUTCFullYear();
  }

}
